<template>
  <b-container>
    <b-card>
      <b-form @submit="updateMapLinkSettings">
        <b-row>
          <b-col sm="12">
            <b-form-group
              label="Map Link *"
              label-for="maplink"
            >
              <b-form-input
                id="maplink"
                v-model="maplink"
                required
              />
            </b-form-group>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button
              type="button"
              class="mr-1"
              variant="light"
            >
              Cancel
            </b-button>
            <b-button
              type="submit"
              :disabled="isLoading"
              variant="primary"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-card>
      <b-card-text>
        Contact Person
        <b-button
          class="ml-2"
          variant="primary"
          :to="{ name: 'admin-settings-contacts-add'}"
        >
          Add Contact
        </b-button>
      </b-card-text>
      <contact-us-table />
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow, BCol, BContainer, BFormGroup, BCard, BFormInput, BButton, BForm, BCardText,
} from 'bootstrap-vue'
import ContactUsTable from './Table.vue'

export default {
  components: {
    BRow, BCol, BContainer, BFormGroup, BCard, BFormInput, BButton, BForm, BCardText, ContactUsTable,
  },

  data() {
    return {
      isLoading: false,
      maplink: '',
    }
  },

  mounted() {
    this.fetchSettings()
  },

  methods: {
    fetchSettings() {
      this.$http.get('/settings/map-link')
        .then(res => {
          this.maplink = res.data.data
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
    },

    updateMapLinkSettings(event) {
      event.preventDefault()
      this.isLoading = true

      this.$http.put('/settings/map-link', {
        map_link: this.maplink,
      })
        .then(() => {
          this.$notif('Success', 'Map Link settings has been successfully updated.', 'success')
          this.fetchSettings()
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
        .finally(() => { this.isLoading = false })
    },
  },
}
</script>
